import React, { useState } from "react";

import { postValidateCommand } from "../../../../../redux/api/picking.api";
import { VerifyCommandProductsListInterface } from "../../../../../redux/interfaces/picking.interface";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";

import ModalWrapper from "../../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../../components/CustomButton";
import Text from "../../../../../styleguide/Text";

function withConfirmationModal<P>(WrappedComponent: React.ComponentType<P>) {
  function WrongQuantityModal(props: P) {
    const dispatch = useAppDispatch();

    const {
      picking: {
        verifyCommandProducts: { data },
      },
    } = useAppSelector((state) => ({
      picking: state.picking,
    }));

    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [reasonType, setReasonType] = useState<number | null>(null);
    const [productSelected, setProductSelected] =
      useState<VerifyCommandProductsListInterface | null>(null);

    const [commandCode, setCommandCode] = useState<string | number | null>(
      null,
    );

    const handleCloseModal = () => {
      setShowModal(false);
      setCommandCode(null);
      setProductSelected(null);
    };

    const handleShowConfirmationModal = ({
      product,
      type,
      commandCodeValue,
    }: {
      product?: VerifyCommandProductsListInterface;
      type?: number;
      commandCodeValue?: string | number | null;
    }) => {
      if (!product || !type || !commandCodeValue) {
        handleCloseModal();
        return;
      }
      setShowModal(true);
      setProductSelected(product);
      setReasonType(type);
      setCommandCode(commandCodeValue);
    };

    const handleValidateCommand = () => {
      if (!productSelected || !reasonType || !data.idUser || !commandCode) {
        return;
      }
      setIsLoadingSave(true);

      dispatch(
        postValidateCommand({
          params: {
            idPozitiePicking: productSelected.idPozitiePicking,
            typeMistake: Number(reasonType),
            idUser: data.idUser,
            commandCode: commandCode,
            op: productSelected.Op,
          },
          callBack: () => {
            setIsLoadingSave(false);
            handleCloseModal();
          },
        }),
      );
    };

    return (
      <>
        <ModalWrapper
          title={`Produs ${productSelected?.bnume}`}
          show={showModal}
          handleClose={() => handleShowConfirmationModal({})}>
          <div className="flex mb-10">
            <Text variant="h5">
              Doriti raportarea unei erori de colectare pentru acest produs?
            </Text>
          </div>
          <div className="flex justify-between">
            <CustomButton
              variant="outlined"
              onClick={() => setShowModal(false)}>
              Anuleaza
            </CustomButton>
            <CustomButton
              variant="contained"
              onClick={handleValidateCommand}
              loading={isLoadingSave}>
              Salveaza
            </CustomButton>
          </div>
        </ModalWrapper>
        <WrappedComponent
          {...props}
          handleShowConfirmationModal={handleShowConfirmationModal}
        />
      </>
    );
  }
  return WrongQuantityModal;
}

export default withConfirmationModal;
